import { IDropdownOption } from "@fluentui/react";
export type categoryDropdownOptionCallback = (list: ICategoryDropdownOption[]) => void;
export type categoryMenuCallback = (menu: MenuModel[]) => void;
export type categoryByTypeCallback = (model: CategoryByTypeModel) => void;
export interface ICategoryDropdownOption extends IDropdownOption {
    level: number;
    IsCollapsed?: boolean;
}

export enum MenuFilterType {
    brand,
    gender,
    type,
    occasion
}

export interface MenuModel {
    index: number;
    index2: number;
    text: string;
    value: number;
    type: MenuFilterType;
    isCheckbox: boolean;
    isSelected: boolean;
    isDisabled: boolean;
    isVisibled: boolean;
    isCollapsed: boolean;
    isNormalText: boolean;
    count: number;
    level: number;
    itemsCount: number;
    lastChild: number;
}

export const createMenuModel = (): MenuModel => ({
    index: 0,
    index2: 0,
    text: "",
    value: 0,
    type: MenuFilterType.type,
    isCheckbox: false,
    isSelected: false,
    isDisabled: false,
    isVisibled: true,
    isCollapsed: false,
    isNormalText: false,
    count: 0,
    level: 0,
    itemsCount: 0,
    lastChild: 0
});

export interface MenuFilterModel {
    type: MenuFilterType;
    value: number;
    text: string;
}

export interface ProductMenuFilterOption {
    hideBrand: boolean;
    hideGender: boolean;
    hideCategory: boolean;
}

export interface CategoryByTypeModel {
    genderIds: number[];
    categoryIds: number[];
}